module.exports = __webpack_public_path__ + "img/bownet.ed93a820.png";